import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'Fragment' },
  __name: 'Fragment',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})